import React, { useCallback } from "react";
import { MdPermScanWifi } from "react-icons/md";
import useTranslation from "../../../hooks/use-translation";
const NotConnected = () => {
    const { translate } = useTranslation();
    const retryHandler = useCallback(() => {
        location.reload();
    }, []);
    return (React.createElement("div", { style: { marginTop: '50%', padding: "10px 10px" } },
        React.createElement("div", { className: "d-flex flex-column w-100" },
            React.createElement("div", { className: '' },
                React.createElement("div", { className: 'rounded-circle d-flex justify-content-center fs-1' },
                    React.createElement(MdPermScanWifi, null))),
            React.createElement("div", { className: 'text-dark mt-5 align-self-center' },
                React.createElement("h1", { className: 'mb-1 text-center' }, translate("not_connected_offline")),
                React.createElement("p", null, translate("not_connected_check"))),
            React.createElement("button", { className: "btn btn-primary align-self-center", onClick: retryHandler }, translate("try_again")))));
};
export default NotConnected;
